<div class="container-ld">
  <div class="row">
    <div class="col-p-12 col-sd-6 col-d-4">
      <div *ngIf="forgotPass">
        <h1 class="title" lang>auth.reset-password-title</h1>
        <h5 class="subtitle" lang>auth.reset-password-sub-title</h5>
      </div>
      <div *ngIf="resetPass">
        <h1 class="title" lang>auth.reset-title</h1>
        <h5 class="subtitle" lang>auth.reset-subtitle</h5>
      </div>
      <div *ngIf="selectedTab === authTabs[0] && !(forgotPass || resetPass)">
        <h1 class="title" lang>login.title</h1>
        <h5 class="subtitle" lang>login.sub-title</h5>
      </div>
      <div *ngIf="selectedTab === authTabs[1] && !(forgotPass || resetPass)">
        <h1 class="title" lang>signup.title</h1>
        <h5 class="subtitle" lang>signup.sub-title</h5>
      </div>

      <div class="margin-form">
        <div class="row tabs">
          <div *ngIf="!forgotPass && !resetPass" class="col-12">
            <hs-tabs [tabs]="authTabs" [auth]="true" [selectedTab]="selectedTab"
              (selectedTabChange)="tabChanged($event)"></hs-tabs>
          </div>
        </div>
        <div *ngIf="selectedTab === authTabs[0] && !(forgotPass || resetPass)">
          <!-- Login form -->
          <hs-login> </hs-login>
        </div>
        <div *ngIf="selectedTab === authTabs[1] && !(forgotPass || resetPass)">
          <!-- Signup form -->
          <hs-signup> </hs-signup>
        </div>
        <div *ngIf="forgotPass">
          <!-- Forgot password form -->
          <hs-forgot-password> </hs-forgot-password>
        </div>
        <div *ngIf="resetPass">
          <!-- Forgot password form -->
          <hs-reset-password></hs-reset-password>
        </div>
      </div>

    </div>

    <div class="col-sd-6 col-d-8">
      <div class="margins d-flex align-items-center">
        <img alt="Woman using computer" src="/assets/signup-images/woman.svg" class="main-image">
      </div>
    </div>
  </div>

</div>
